import React, { createContext } from "react";
export var ProductOrderContext = createContext(undefined);
var ProductOrdersProvider = function (props) {
    return (React.createElement(ProductOrderContext.Provider, { value: props === null || props === void 0 ? void 0 : props.value }, props === null || props === void 0 ? void 0 : props.children));
};
export default ProductOrdersProvider;
